export default __webpack_public_path__ + "static/media/calendar-icon.e5dc9c45.svg";